import { useCallback } from 'react'
import { FlatList } from 'react-native'

import { zodResolver } from '@hookform/resolvers/zod'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { Button, colors, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { KeyBoardWrapper } from '@zet/utils'
import { useUnsafeVariable } from 'nativewind'
import { useForm } from 'react-hook-form'

import { Banner, HeaderDetailsSection } from '../../components'
import FormController from '../../form/FormController'
import { useAddCustomerState } from '../../hooks/useAddCustomer'
import useGetAgentDetailsAndTheme from '../../hooks/useGetAgentDetailsAndTheme'
import { customerDetailsValidationSchema } from '../../utils/validationSchemas'
import { customerDetailsFormFields } from './formFields'

export const CustomerDetails = () => {
  const { bannerImage } = useGetAgentDetailsAndTheme()
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm({
    mode: 'onTouched',
    resolver: zodResolver(customerDetailsValidationSchema),
  })
  const { customerId, setCustomerPhoneNumber } = useAddCustomerStore()

  const { mutate, isLoading } = useAddCustomerState()

  const renderItem = useCallback(({ item }) => {
    return <FormController control={control} ocField={item} />
  }, [])

  const hndleContinue = () => {
    const {
      email,
      employmentType,
      fullName,
      annualIncome,
      phoneNumber,
      pinCode,
      modeOfIncome,
    } = getValues()
    setCustomerPhoneNumber(phoneNumber)
    const urlParams = new URLSearchParams(window.location.search)
    const hash = encodeURIComponent(urlParams.get('hash') || '')
    const custId = urlParams.get('customerId')
    const requestBodyData = {
      hash,
      customerId: customerId || custId,
      email: email,
      employmentType: employmentType,
      fullName: fullName,
      annualIncome: Math.trunc(Number(annualIncome)),
      phoneNumber: phoneNumber,
      pinCode: pinCode,
      modeOfIncome: modeOfIncome,
      screenName: 'SHOWN_QUICK_BASIC_DETAILS_SCREEN',
    }
    mutate(requestBodyData)
  }

  return (
    <KeyBoardWrapper
      BottomSheet={
        <Stack className="border-t-grays-30 border-t px-3 py-2">
          <Button
            className="w-full"
            size={'lg'}
            disabled={!isValid}
            style={{
              backgroundColor: isValid ? colorPrimary100 : colors.grays[50],
            }}
            loading={isLoading}
            onPress={hndleContinue}
          >
            {i18n.t('bottomView.continue')}
          </Button>
        </Stack>
      }
    >
      <Stack className="bg-white px-3">
        {/* Banner */}
        <Banner img={bannerImage} />

        <FlatList
          showsVerticalScrollIndicator={false}
          data={customerDetailsFormFields}
          ListHeaderComponent={
            <HeaderDetailsSection
              subTitle="Please add your details to check your eligibility"
              title="Provide Your Details"
            />
          }
          renderItem={renderItem}
        />
      </Stack>
    </KeyBoardWrapper>
  )
}
